function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Button } from 'reactstrap';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import useActionsTypes from "../../actions-types.hook";
import FixedInput from "./timer/fixed";
import PlageInput from "./timer/plage";
import { _translate as t } from "../../../../services/core";
import 'bootstrap-slider/dist/css/bootstrap-slider.css';
import { formatTimeToRange } from "./convert";

/**
 * Time slider (simple)
 * Time range slider (simple choix : plage horaire)
 *
 * On enregistre 3 valeurs (min, mid, max)
 *
 * @see https://github.com/brownieboy/react-bootstrap-slider
 */
var TimeInput = function TimeInput(props) {
  var onChange = props.onChange,
    index = props.index;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    responses = collector.responses;
  var _useState = useState({
      min: '00h00',
      max: '00h00',
      mid: '00h00'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(function () {
      if (value.min === -1 && value.max === -1 && value.mid === -1) {
        return 'variable';
      } else {
        return value.mid === value.min && value.mid === value.max ? 'fixed' : 'plage';
      }
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    timeType = _useState4[0],
    setTimeType = _useState4[1];
  var _useActionsTypes = useActionsTypes(),
    defaultValue = _useActionsTypes.defaultValue;
  var tagOnchange = function tagOnchange(tType) {
    /* if (tType === "fixed" && (value.mid === value.min && value.mid === value.max)) {
      let mid = (value.max - value.min)/2
      setValue({ min: mid, max: mid, mid: mid });
    }
     if (tType === "plage" && typeof value === "number") {
      const min = value.mid - 1 <= 0 ? 0 : value - 1;
      const max = value.mid + 1 >= 23.99 ? 23.99 : value + 1;
      setValue({ min: min, max: max, mid: -1 });
    }
     if (tType === "variable") {
      onChange(value, [{ min: -1, max: -1, mid: -1 }], null, index);
    } */

    setTimeType(tType);
  };
  var getTimerInput = function getTimerInput(e) {
    switch (e) {
      case 'fixed':
        if (value.max === value.min) {
          if (value.mid === -1) {
            onChange(value, [{
              min: '00h00',
              max: '00h00',
              mid: '00h00'
            }], null, index);
            setValue({
              min: '00h00',
              max: '00h00',
              mid: '00h00'
            });
            return /*#__PURE__*/React.createElement(FixedInput, {
              onChangeValue: HandleTimer,
              value: {
                min: '00h00',
                max: '00h00',
                mid: '00h00'
              }
            });
          } else {
            return /*#__PURE__*/React.createElement(FixedInput, {
              onChangeValue: HandleTimer,
              value: value
            });
          }
        }
        var hourmin = parseInt(value.min.split('h')[0]);
        var minutemin = parseInt(value.min.split('h')[1]);
        var hourmax = parseInt(value.max.split('h')[0]);
        var minutemax = parseInt(value.max.split('h')[1]);
        var newres = (hourmax * 60 + minutemax + (hourmin * 60 + minutemin)) / 2;
        var newHour = (newres - newres % 60) / 60 < 10 ? '0' + (newres - newres % 60) / 60 : (newres - newres % 60) / 60;
        var newMinute = newres % 60 < 10 ? '0' + newres % 60 : newres % 60;
        newres = newHour + 'h' + newMinute;
        onChange(value, [{
          min: newres,
          max: newres,
          mid: newres
        }], null, index);
        setValue({
          min: newres,
          max: newres,
          mid: newres
        });
        return /*#__PURE__*/React.createElement(FixedInput, {
          onChangeValue: HandleTimer,
          value: {
            min: newres,
            max: newres,
            mid: newres
          }
        });
      case 'plage':
        if (value.mid === value.min && value.mid === value.max) {
          if (value.mid === -1) {
            onChange({
              min: '00h00',
              max: '01h00',
              mid: '00h00'
            }, [{
              min: '00h00',
              max: '01h00',
              mid: '00h00'
            }], null, index);
            setValue({
              min: '00h00',
              max: '01h00',
              mid: '00h00'
            });
            return /*#__PURE__*/React.createElement(PlageInput, {
              onChangeValue: HandleTimer,
              value: {
                min: '00h00',
                max: '01h00',
                mid: '00h30'
              }
            });
          } else {
            var hourmid = parseInt(value.mid.split('h')[0]);
            var minutemid = parseInt(value.mid.split('h')[1]);
            var min = hourmid - 1 <= 0 ? 0 : hourmid - 1;
            var max = hourmid + 1 >= 23 ? 23 : hourmid + 1;
            min = min < 10 ? '0' + min : min;
            max = max < 10 ? '0' + max : max;
            hourmid = hourmid < 10 ? '0' + hourmid : hourmid;
            minutemid = minutemid < 10 ? '0' + minutemid : minutemid;
            onChange(value, [{
              min: min + 'h' + minutemid,
              max: max + 'h' + minutemid,
              mid: value.mid
            }], null, index);
            setValue({
              min: min + 'h' + minutemid,
              max: max + 'h' + minutemid,
              mid: value.mid
            });
            return /*#__PURE__*/React.createElement(PlageInput, {
              onChangeValue: HandleTimer,
              value: {
                min: min + 'h' + minutemid,
                max: max + 'h' + minutemid,
                mid: value.mid
              }
            });
          }
        }
        return /*#__PURE__*/React.createElement(PlageInput, {
          onChangeValue: HandleTimer,
          value: value
        });
      case 'variable':
        if (value.mid !== -1) {
          onChange(value, [{
            min: -1,
            max: -1,
            mid: -1
          }], null, index);
          setValue({
            min: -1,
            max: -1,
            mid: -1
          });
        }
        return /*#__PURE__*/React.createElement("div", null);
      default:
        return;
    }
  };
  var handleOnChange = function handleOnChange(valueChanged, response) {
    setValue(valueChanged);
    onChange(response, [valueChanged], null, index);
  };
  var HandleTimer = function HandleTimer(e) {
    handleOnChange(e, value);
  };
  useEffect(function () {
    var _currentResponse$resp;
    var currentResponse = Collector.getCurrentOrderResponses(currentOrder, responses);
    if (!currentResponse || !currentResponse.responses) {
      return;
    }
    var keys = Object.keys(currentResponse.responses);
    if (keys.length === 0) {
      return;
    }
    var res = formatTimeToRange(currentResponse.responses[keys[0]]);
    if (currentResponse.responses[keys[0]] === -1 || ((_currentResponse$resp = currentResponse.responses[keys[0]]) === null || _currentResponse$resp === void 0 ? void 0 : _currentResponse$resp.mid) === -1) {
      setTimeType('variable');
      setValue({
        min: -1,
        max: -1,
        mid: -1
      });
    } else {
      var _currentResponse$resp2;
      if ((_currentResponse$resp2 = currentResponse.responses[keys[0]]) !== null && _currentResponse$resp2 !== void 0 && _currentResponse$resp2.min) {
        typeof res === 'number' ? setTimeType('fixed') : setTimeType('plage');
        setValue(currentResponse.responses[keys[0]]);
      } else {
        setValue({
          min: '00h00',
          max: '00h00',
          mid: '00h00'
        });
      }
    }
  }, [collector]);
  useEffect(function () {
    var valueFromBase = defaultValue();
    if (!valueFromBase) {
      return;
    }
    setValue(valueFromBase);
  }, []);
  if (!currentOrder) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "col-auto checkbox-tag"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "collectorCheckboxTag input-time-tag ".concat(timeType === 'fixed' ? 'active' : ''),
    onClick: function onClick() {
      return tagOnchange('fixed');
    }
  }, t('collectorapp_time_is_fixed'))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto checkbox-tag"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "collectorCheckboxTag input-time-tag ".concat(timeType === 'plage' ? 'active' : ''),
    onClick: function onClick() {
      return tagOnchange('plage');
    }
  }, t('collectorapp_time_is_range'))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto checkbox-tag"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "collectorCheckboxTag input-time-tag ".concat(timeType === 'variable' ? 'active' : ''),
    onClick: function onClick() {
      return tagOnchange('variable');
    }
  }, t('collectorapp_time_variable')))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-2"
  }, getTimerInput(timeType)));
};
TimeInput.propTypes = {
  onChange: PropTypes.func.isRequired
};
TimeInput.defaultProps = {
  responses: {}
};
export default TimeInput;